module.exports = __webpack_public_path__ + "815ceb56b2ab9050fccfea9747c569ca.pdf";